import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type AuthAction = ActionType<typeof actions>;

export enum AuthActionTypes {
  FETCH_REQUEST = "@Token/FETCH_REQUEST",
  FETCH_SUCCESS = "@Token/FETCH_SUCCESS",
  FETCH_ERROR = "@Token/FETCH_ERROR",
  FETCH_LOCAL_STORAGE = "@Token/FETCH_LOCAL_STORAGE",

  LOGOUT = "@Token/LOGOUT",
}

export interface AuthState {
  readonly hasToken: boolean;
  readonly isLoading: boolean;
}
